import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import registerClosureTemplate from '../../templates/register-closure/index.html'
import closeRegisterTemplate from '../../templates/register-closure/close-register.html'
import openRegisterTemplate from '../../templates/register-closure/open-register.html'
import { ROUTES, STATES } from '../../../lib/routes'
import { RegisterManager } from '../managers/register-manager'
import { getFeatureFromCache } from '../util/feature-cache'
import { REACT_REGISTER_OPEN_CLOSE } from '../constants'

/**
 * =======================================
 * ROUTES CONFIG - REGISTER CLOSURE
 * =======================================
 *
 * @module webregister.routes.register-closure
 */
function RegiserClosureRoutesConfig($stateProvider: StateProvider) {
  const useReact = getFeatureFromCache(REACT_REGISTER_OPEN_CLOSE)

  if (useReact) {
    const template = '<react-register-open-close></react-register-open-close>'
    $stateProvider
      .state(STATES.REGISTER_CLOSURE, {
        url: ROUTES.REGISTER_CLOSURE,
        template,
      })
      // The above state handles if we're directed by URL but we also need to handle
      // all of the existing UIRouter states that Webregister might direct to.
      .state(STATES.RESOLVE_REGISTER_CLOSURE_STATE, {
        template,
      })
      .state(STATES.CLOSE_REGISTER, {
        template,
      })
      .state(STATES.OPEN_REGISTER, {
        template,
      })

    return
  }

  $stateProvider
    .state(STATES.REGISTER_CLOSURE, {
      url: ROUTES.REGISTER_CLOSURE,
      template: registerClosureTemplate,
      abstract: true,
    })
    // @note This state allows us to have 2 separate states for open/close register with the same URL (allowing
    // the user to refresh the page and end up in the correct state based on register status). The actual final
    // state is determined in a resolver function.
    .state(STATES.RESOLVE_REGISTER_CLOSURE_STATE, {
      // @note The blank URL ensures this state is activated if navigating to its abstract parent's URL
      url: '',
      redirectTo: transition => {
        return transition
          .injector()
          .getAsync('registerManager')
          .then((registerManager: RegisterManager) => {
            if (registerManager.isActiveRegisterOpen()) {
              return STATES.CLOSE_REGISTER
            } else {
              return STATES.OPEN_REGISTER
            }
          })
      },
    })
    .state(STATES.CLOSE_REGISTER, {
      template: closeRegisterTemplate,
      controller: 'CloseRegisterController',
      controllerAs: '$ctrl',
    })
    .state(STATES.OPEN_REGISTER, {
      template: openRegisterTemplate,
      controller: 'OpenRegisterController',
      controllerAs: '$ctrl',
    })
}

angular.module('webregister.routes').config(RegiserClosureRoutesConfig)
